import classNames from 'classnames'
import { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { UAParser } from 'ua-parser-js'

import { useDeviceReferral } from '@pages/Referral/DeviceReferral'

import { useSessionEntity } from '@context/EntityContext'

import { Caption1, Title1 } from '@ui/Typography'
import { Link } from '@ui/components/Link'

import { isTickmillUKType } from '@utils/companyName.utils'

import { OperatingSystemNameEnum } from '@model/PlatformTypeEnum'

import { APKBanner } from '@assets/banners/APK.banner'
import { AppStoreBanner } from '@assets/banners/AppStore.banner'
import { PlayStoreBanner } from '@assets/banners/PlayStore.banner'

import styles from './AppMarketLink.module.scss'

interface AppMarketLinkProps {
  justIcons?: boolean
  wrapperClassName?: string
  hideCFDMessage?: boolean
  spacing?: boolean
}

export const AppMarketLink = (props: AppMarketLinkProps): JSX.Element => {
  const { t } = useTranslation()
  const { justIcons, spacing = true, wrapperClassName, hideCFDMessage } = props
  const parser = new UAParser()
  const { os } = parser.getResult()
  const { referralAppLink } = useDeviceReferral()

  const isIOS = os.name === OperatingSystemNameEnum.iOS
  const isAndroid = os.name === OperatingSystemNameEnum.Android
  const isOtherDevice = !isIOS && !isAndroid

  const entity = useSessionEntity()

  return (
    <div
      className={classNames(styles.wrapper, wrapperClassName, {
        [styles.justIcons]: justIcons,
        [styles.spacing]: spacing,
      })}
    >
      {!justIcons && (
        <Title1 isParagraph className={styles.title}>
          {t('Download the Tickmill Mobile App')}
        </Title1>
      )}

      {isIOS && (
        <Link href={referralAppLink()}>
          <AppStoreBanner />
        </Link>
      )}

      {isAndroid && (
        <>
          <Link href={referralAppLink()}>
            <PlayStoreBanner />
          </Link>
          <div>
            <Link href='https://tickmill.link/AppReleaseLatest_apk'>
              <APKBanner />
            </Link>
          </div>
        </>
      )}
      {isOtherDevice && (
        <>
          <div>
            <Link href='https://apps.apple.com/app/tickmill/id1548644102'>
              <AppStoreBanner />
            </Link>
          </div>

          <div>
            <Link href='https://play.google.com/store/apps/details?id=com.tickmill'>
              <PlayStoreBanner />
            </Link>
          </div>

          <div>
            <Link href='https://tickmill.link/AppReleaseLatest_apk'>
              <APKBanner />
            </Link>
          </div>
        </>
      )}
      {!hideCFDMessage && isTickmillUKType(entity) && (
        <div className='mt-5'>
          <Caption1 isParagraph medium>
            * {t('Only available for services related to CFD')}
          </Caption1>
        </div>
      )}
    </div>
  )
}
